import React, { useState, useEffect, useContext } from 'react';
import { GridToolbar } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { fetchInstructorsData } from "../../services";
import { MyContext } from '../..';

export default function InstructorList(props) {
    document.title = props.title;
    const { backendUrl } = useContext(MyContext);
    const queryParameters = new URLSearchParams(window.location.search);
    const subscriberCode = queryParameters.get("subcode")?.toUpperCase() || props.subcode;
    const [instructorData, setInstructorsData] = useState([]);

    const columns = [
        { field: 'id', headerName: 'Id', width: 100 },
        { field: 'full_name', headerName: 'Name', width: 200 },
        { field: 'username', headerName: 'Username', width: 200 },
        { field: 'email', headerName: 'email', width: 200 },
        { field: 'phone_number', headerName: 'Phone Number', width: 150 },
        { field: 'created_on', headerName: 'Created On', width: 150 },
        { field: 'description', headerName: 'Description', width: 150 },
    ];

    useEffect(() => {
        async function fetchData() {
            try {
                const data = await fetchInstructorsData(backendUrl, subscriberCode);
                setInstructorsData(data.data);
            } catch (error) {
                console.error('Error fetching instructor data:', error);
            }
        }
        fetchData();
    }, [backendUrl, subscriberCode]);

    return (
        <>
            <div style={{ height: "80vh", width: '100%' }}>
                <DataGridPro rows={instructorData} columns={columns} slots={{ toolbar: GridToolbar }} slotProps={{toolbar: {showQuickFilter: true,},}} initialState={{sorting: {sortModel: [{ field: 'id', sort: 'desc' }],},}} pagination/>
            </div>
        </>
    );
}
